import { getTranslationOrInnerText, isHTMLElement } from 'whisper-base';
import { NudgeTypes } from '../constants';
export const Definition = {
  selector: '[data-test-id="banner-notification"]',
  shouldTrackRenderedForChild: () => {
    return true;
  },
  shouldTrackDismissedForChild: () => {
    return true;
  },
  getNudgeProperties: ({
    element
  }) => {
    const subjectElement = element.querySelector(`[data-test-id="alertTitle"]`);
    const title = isHTMLElement(subjectElement) ? getTranslationOrInnerText(subjectElement) : 'no-subject';
    return {
      type: NudgeTypes.ALERT_GLOBAL,
      title
    };
  }
};